import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

const Container = styled.div`
  ${({ theme }) => theme.preOrderCallout};
`;

export default function PreorderTag({ className, dataAutotag }) {
  return (
    <Container className={className} data-autotag={dataAutotag}>
      <FormattedMessage
        id="site_pdp.pre_order_tag"
        defaultMessage="Pre-Order"
      />
    </Container>
  );
}

PreorderTag.propTypes = {
  className: PropTypes.string,
  dataAutotag: PropTypes.string,
};
